












































































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import CTimeInput from '~/components/shared/configurable/datetime/CTimeInput.vue'
import { parseDate, setHours, setMinutes } from '~/utils/date'
import { useLogger } from '~/compositions/logger'
import { useTime } from '~/compositions/datetime/time'
import { useDeps } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { useSnackbar } from '~/compositions/snackbar'
import CDatePicker from '~/components/shared/configurable/date/CDatePicker.vue'
import { handleError } from '~/utils/http'
import { useI18n } from '~/compositions/i18n'
import AuditRequestContactInfo from '~/components/shared/audits/request/AuditRequestContactInfo.vue'
import { AuditRequest } from '~/models/audit/request'

export default defineComponent({
  props: {
    date: {
      type: Date,
      default: null
    },
    time: {
      type: String,
      default: '09:00'
    },
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    },
    changeMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    AuditRequestContactInfo,
    CTimeInput,
    CDatePicker
  },
  setup(props, { emit }) {
    const selectedDate = ref<Date | null>(props.date)
    const selectedTime = ref(null)
    const { auditRequest } = toRefs(props)
    const error = ref('')
    const loading = ref(false)

    const contactedSeller = ref(false)
    const showContactInfo = ref(false)

    const snackbar = useSnackbar()
    const logger = useLogger()
    const { t } = useI18n()
    const { extractHoursAndMinutesFromTimeString } = useTime()
    const [auditRequestService] = useDeps(AuditRequestService)

    function handleCancelButtonClick() {
      emit('cancel')
    }

    const bothDateAndTimeAreSet = computed(() =>
      Boolean(selectedDate.value && selectedTime.value)
    )
    const datepickerMinDate = computed(() => new Date())
    const datepickerMaxDate = computed(
      () =>
        auditRequest.value.finalExpirationDate &&
        parseDate(auditRequest.value.finalExpirationDate, 'd/M/yyyy HH:mm')
    )

    async function handleSubmitButtonClick() {
      if (!bothDateAndTimeAreSet.value) {
        return
      }
      const [hours, minutes] = extractHoursAndMinutesFromTimeString(
        selectedTime.value
      )
      let appointmentDateTime = selectedDate.value!
      appointmentDateTime = setHours(appointmentDateTime, hours)
      appointmentDateTime = setMinutes(appointmentDateTime, minutes)
      try {
        loading.value = true
        await auditRequestService.setAppointmentDate(
          auditRequest.value.id,
          appointmentDateTime
        )
        snackbar.success('Το ραντεβού αποθηκεύτηκε')
        emit('success')
      } catch (err) {
        const appointmentError = (err as any).response?.data?.data?.errors
          ?.appointment_date
        error.value = appointmentError

        if (!appointmentError) {
          handleError(err, snackbar, logger, t)
        }
      } finally {
        loading.value = false
      }
    }

    function handleDateInput() {
      error.value = ''
    }

    function handleTimeChange() {
      error.value = ''
    }
    return {
      selectedDate,
      selectedTime,
      handleCancelButtonClick,
      bothDateAndTimeAreSet,
      datepickerMinDate,
      datepickerMaxDate,
      handleSubmitButtonClick,
      error,
      handleDateInput,
      handleTimeChange,
      contactedSeller,
      showContactInfo,
      loading
    }
  }
})
